<template>
  <v-container class="pa-0">
    <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
      <page-header-title :title="page_title"></page-header-title>

      <v-spacer></v-spacer>

      <action-button type="back" @click="$router.go(-1)" />
      <action-button type="save" @click="save" />
    </v-app-bar>

    <v-card>
      <v-card-text class="pa-4">
        <v-form ref="form">
          <v-flex md12>
            <action-button small type="default" :text="$t('roles.check_all')" @click="autoselect('all')" color="success" />
            <action-button small type="default" :text="$t('roles.check_all_access')" @click="autoselect('access')" />
            <action-button small type="default" :text="$t('roles.check_all_create')" @click="autoselect('create')" />
            <action-button small type="default" :text="$t('roles.check_all_edit')" @click="autoselect('edit')" />
            <action-button small type="default" :text="$t('roles.check_all_delete')" @click="autoselect('delete')" />
            <action-button small type="default" :text="$t('roles.uncheck_all')" @click="autoselect('none')" color="error" />

            <v-divider class="mt-4"></v-divider>

            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th scope="col" width="20%">
                      {{ $t("permissions.module") }}
                    </th>
                    <th scope="col">{{ $t("permissions.title") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in all_permissions" :key="item.id">
                    <td scope="row">{{ $dd_modules(item.module) }}</td>
                    <td>
                      <span v-for="data in item.permissions" :key="data.id" class="perm-row">
                        <input
                          v-model="checked"
                          type="checkbox"
                          name="chk_permission"
                          :value="data.name"
                          :checked="checked.includes(data.name)"
                        />
                        {{ data.name }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-flex>
        </v-form>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "UserPermissions",

  props: ["id"],

  data() {
    return {
      page_title: "",
      role: {},
      permissions: [],
      all_permissions: [],
      checked: []
    }
  },

  created() {
    let vm = this

    if (!this.id) {
      this.role = {}
    } else {
      // Get role
      axios
        .get(this.API_URL + "role/" + this.id)
        .then((res) => {
          this.role = res.data.data
          this.permissions = res.data.data.permissions

          this.page_title = this.$t("roles.permission_role", {
            name: this.role.name
          })

          // Get role permissions
          axios
            .get(this.API_URL + "permissions?show_all=true")
            .then((res) => {
              let _permissions = res.data.data
              let _all_permissions = []

              // save all the permissions to "all_permissions" variable and group it by module
              for (let _module of vm.$dd_modules()) {
                _all_permissions.push({
                  module: _module.key,
                  permissions: _permissions.filter((_permission) => _permission.module === _module.key)
                })
              }

              this.all_permissions = _all_permissions

              // set checked permission
              this.permissions.forEach(function(value) {
                vm.checked.push(value.name)
              })
            })
            .catch((err) => console.log(err))
        })
        .catch((err) => console.log(err))
    }
  },

  methods: {
    save() {
      let vm = this

      axios
        .post(this.API_URL + "role/permissions", {
          id: vm.id,
          permissions: vm.checked
        })
        .then((res) => {
          let data = res.data.data

          if (data.id) {
            vm.$store.dispatch("auth/updateUserState", vm)
            vm.$awn.success(vm.$t("global.create_success"))
          }
        })
        .catch((err) => console.log(err))
    },
    autoselect(type) {
      let permissions = this.all_permissions
        .map((i) => i.permissions.map((p) => p.name))
        .reduce((l, item) => {
          l.push(...item)
          return l
        }, [])

      switch (type) {
        case "none":
          this.checked = []
          break
        case "all":
          this.checked = permissions
          break
        case "access":
        case "create":
        case "edit":
        case "delete":
          permissions = permissions.filter((val, key) => {
            return val.includes("-" + type)
          })

          this.checked.push(...permissions)
          break
      }
    }
  }
}
</script>

<style scoped>
.perm-row {
  margin-right: 10px;
}
</style>
